/*  ==========================================================================
    DYNFORMS CONFIG
    ========================================================================== */

// local imports
import * as dynFileLoader from './../../utilities/lib/dyn-file-loader';
import { dynForms } from './config';
import * as vars from '../../globals/variables';
import $ from 'jquery';

const BN = (window.BN = window.brandnamic = window.brandnamic || window.BN || {});

function addFormToContainer(form, dynFormConfigObject, additionalConfigObject) {
    if (!form.classList.contains('bn-dynformInit')) {
        let containerId = form.id;
        let confirmPath = document
            .querySelector("meta[name='confirm-path']")
            .getAttribute('content');

        let containerFormConfig = $.extend({}, dynFormConfigObject, {
            formContainerId: containerId,
            doubleOptUrl:
                'https://confirm.brandnamic.com/?lang=' +
                vars.lang +
                '&redirect=' +
                window.location.protocol +
                '//' +
                window.location.host +
                confirmPath,
        });

        let dynFormConfig = $.extend({}, containerFormConfig, additionalConfigObject);

        if (BN.DynFormsV2) {
            BN.DynFormsV2(dynFormConfig);
        }
    }
}

const initDynform = additionalConfig => {
    let additionalConfigObject = additionalConfig || {};

    if (additionalConfigObject.formContainerId) {
        let formContainer = document.getElementById(additionalConfig.formContainerId);
        let formCode = formContainer.dataset.dynformcode;

        let mergedConfig = $.extend({}, vars.dynformsGlobalConfig, dynForms[formCode]);
        mergedConfig.dynFormCode = formCode;

        addFormToContainer(formContainer, mergedConfig, additionalConfigObject);
    } else {
        // Trigger each dynformCodes
        for (let formCode in dynForms) {
            if (dynForms.hasOwnProperty(formCode)) {
                let mergedConfig = $.extend({}, vars.dynformsGlobalConfig, dynForms[formCode]);
                mergedConfig.dynFormCode = formCode;

                let formContainer = document.querySelectorAll(
                    '[data-dynFormCode="' + formCode + '"]'
                );
                formContainer.forEach(form => {
                    addFormToContainer(form, mergedConfig, additionalConfigObject);
                });
            }
        }
    }
};

const dynFileConfig_dynForm = {
    dynForm: {
        src: 'https://admin.ehotelier.it/js/dynformsv2.js',
        onLoad: () => {
            // Save callback variable to the window variable, to initialize the dynform script also on async requests
            BN.DynFormsV2 = BnForms.DynFormsV2;
            initDynform();
        },
    },
};

// const dynFileConfig_referrer = {
//     referer: {
//         src: 'https://referrer.bnamic.com/referrer/referrer.js',
//         onLoad: () => {
//             dynFileLoader.load(dynFileConfig_dynForm, 'js');
//         },
//         onError: () => {
//             dynFileLoader.load(dynFileConfig_dynForm, 'js');
//         },
//     },
// };
dynFileLoader.load(dynFileConfig_dynForm, 'js');

export { initDynform };



// WEBPACK FOOTER //
// ./source/js/ehotelier/dynforms/init.js